import type { NDateLocale } from './enUS'
import { hr } from 'date-fns/locale'

const dateHrHR: NDateLocale = {
  name: 'hr-HR',
  locale: hr
}

export default dateHrHR
